// Czech dictionary — keep structurally identical to en.js.
const cz = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Zažijte badmintonové turnaje v krásném městě Trenčín',
    info: 'INFO',
    book: 'REZERVOVAT UBYTOVÁNÍ',
  },

  home: {
    upcomingTitle: 'Nadcházející akce v roce 2026',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Již brzy',
    eventDateShort: '25.–27. září',
  },

  tournament: {
    entryDeadline: 'Uzávěrka přihlášek:',
    upcoming: 'Již brzy',
    deadlineU17: '25. srpna 2026',
    deadlineU13: '11. září 2026',
    eventDate: '25.–27. září 2026',
    invitation: 'POZVÁNKA',
    register: 'REGISTRACE',
    draws: 'LOSOVÁNÍ',
    acceptanceList: 'SEZNAM ÚČASTNÍKŮ',
    infoTitle: 'Informace o turnaji',
    entryFees: 'Startovné:',
    singles25: 'Dvouhra = 25 €',
    singles40: 'Dvouhra = 40 €',
    doubles20: 'Čtyřhra = 20 € / hráč',
    doubles30: 'Čtyřhra = 30 € / hráč',
    feesPayment: 'Startovné je nutné uhradit bankovním převodem před akcí nebo v hotovosti (EUR) pořadateli během akce.',
    shuttlesLabel: 'Oficiální míče turnaje:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: 'Na každý zápas budou poskytnuty 2 míče, další si účastníci zajišťují sami. Míče KAWASAKI SHUTTLECOCK TEAM 1 lze zakoupit u pořadatele.',
    managersMeeting: 'Porada vedoucích družstev:',
    meetingU17: 'Čtvrtek 24. září 2026 v 19:00 v hale.',
    mainEvent: 'Hlavní soutěž',
    finals: 'Finále',
    provisionalNote: 'ⓘ Předběžné časy se mohou změnit v závislosti na počtu přihlášených. Konečný časový harmonogram (s přesným plánovaným koncem všech zápasů) bude zveřejněn na webu nejpozději 20 dní před začátkem turnaje.',
    seedingNote: 'Nasazení a losování byly provedeny podle žebříčku BEC European U17 ze 17. září.',
    koSystemNote: 'Dvouhry se v první fázi hrají ve skupinách a následně vyřazovacím (KO) systémem; čtyřhry se hrají vyřazovacím systémem. V případě jakéhokoli sporu je rozhodnutí vrchního rozhodčího konečné.',
    day25: '25. září',
    day26: '26. září',
    day27: '27. září',
  },

  info: {
    heroTitle: 'Informace',
    contactsTitle: 'Kontakty a poloha',
    director: 'Ředitel turnaje:',
    contactPerson: 'Kontaktní osoba:',
    phoneNumber: 'Telefon:',
    email: 'Email:',
    venue: 'Místo konání:',
    transportTitle: 'Doprava',
    transportIntro: 'Pořadatel zajišťuje dopravu za poplatek z:',
    transportDetails: 'Údaje o své cestě zašlete co nejdříve na sj.bedminton@gmail.com. Poplatky za dopravu je nutné uhradit bankovním převodem před akcí nebo v hotovosti (EUR) pořadateli během akce.',
    transportWalking: 'Všechny oficiální hotely jsou v docházkové vzdálenosti od haly, doprava mezi halou a hotely se proto nezajišťuje.',
    mealsDesc: 'Restaurace je součástí haly. Obědy a večeře se podávají formou bufetu s výběrem jídel – all you can eat:',
    transportBa: 'Letiště BRATISLAVA = 30 € / osoba / jeden směr',
    transportVie: 'Letiště VÍDEŇ = 40 € / osoba / jeden směr',
    accomTitle: 'Ubytování',
    accomOrder: 'Ubytování se objednává přímo přes náš online rezervační formulář.',
    accomPayment: 'Ubytování je nutné uhradit bankovním převodem před turnajem nebo v hotovosti (EUR) pořadateli ihned po příjezdu do sportovní haly. Platí se za pokoj, nikoli za osobu.',
    breakfastIncluded: 'Snídaně v ceně',
    doubleRoom85: 'Dvoulůžkový pokoj = 85 €/noc',
    tripleRoom100: 'Třílůžkový pokoj = 100 €/noc',
    fourRoom110: 'Čtyřlůžkový pokoj = 110 €/noc',
    doubleRoom95: 'Dvoulůžkový pokoj = 95 €/noc',
    tripleRoom110: 'Třílůžkový pokoj = 110 €/noc',
    singleRoom65: 'Jednolůžkový pokoj = 65 €/noc',
    apartment170: 'Apartmán (2–4 osoby) = 170 €/noc',
    apartmentMinStay: 'Minimální pobyt = 3 noci. Snídaně v ceně.',
    apartmentDesc: 'Apartmán obsahuje: 2 samostatné dvoulůžkové pokoje, koupelnu, kuchyň, obývací pokoj, pračku.',
    distVenue: 'Přímo v místě konání.',
    dist14: '1,4 km od místa konání.',
    dist19: '1,9 km od místa konání.',
    servicesTitle: 'Další služby',
    stringing: 'Vyplétání raket:',
    stringingAvail: 'K dispozici po celou dobu akce:',
    stringingOnly: 'Vypletení = 10 €',
    stringingNew: 'Vypletení + nový výplet = 18 €',
    meals: 'Strava:',
    lunch: 'Oběd = 12 €',
    dinner: 'Večeře = 12 €',
  },

  booking: {
    headerTitle: 'Rezervace ubytování',
    headerSub: 'Slovak Junior & Youth · Trenčín',
    step1Title: 'Vyberte turnaj',
    underAge: (age) => `Do ${age} let`,
    contactTitle: 'Kontaktní údaje',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    phone: 'Telefon',
    email: 'Email',
    emailInvalid: 'Zadejte platnou e-mailovou adresu',
    selectCountry: 'Vyberte zemi',
    searchCountry: 'Hledat zemi…',
    chooseHotel: 'Vyberte hotel',
    checkingAvail: 'ověřuji dostupnost…',
    availUnknown: 'Dostupnost se nepodařilo ověřit — zobrazené počty nemusí být aktuální.',
    unavailable: 'Obsazeno',
    selfCatering: 'Bez stravy',
    breakfast: 'Snídaně v ceně',
    atVenue: 'V místě konání · 0 km',
    fromVenue14: '1,4 km od místa konání',
    fromVenue19: '1,9 km od místa konání',
    rooms: 'Pokoje',
    perNight: '€ / noc',
    addRoom: 'Přidat pokoj',
    soldOut: 'Vyprodáno',
    minNights3: 'Apartmány vyžadují minimální pobyt 3 noci.',
    noRoomsLeft: 'V tomto hotelu už nejsou volné pokoje',
    onlyRoomsLeft: (n) => `V tomto hotelu ${n === 1 ? 'zbývá už jen 1 pokoj' : `zbývají už jen ${n} pokoje`}`,
    roomsAvailable: (n, total) => `Volné pokoje: ${n} z ${total}`,
    selectedRooms: 'Vybrané pokoje',
    remove: 'Odstranit',
    checkin: 'Příjezd',
    checkout: 'Odjezd',
    nights: (n) => `${n} ${n === 1 ? 'noc' : n < 5 ? 'noci' : 'nocí'}`,
    personFirst: (i) => i === 1 ? 'Jméno (osoba 1)' : `Jméno (osoba ${i}, nepovinné)`,
    personLast: (i) => i === 1 ? 'Příjmení (osoba 1)' : `Příjmení (osoba ${i}, nepovinné)`,
    addAnotherRoom: 'Přidat další pokoj',
    summaryTitle: 'Shrnutí rezervace',
    tournamentLabel: 'Turnaj:',
    hotelLabel: 'Hotel:',
    contactLabel: 'Kontakt:',
    phoneLabel: 'Telefon:',
    emailLabel: 'Email:',
    person: 'Osoba',
    estimatedTotal: 'Cena celkem',
    paymentNote: 'Ubytování je nutné uhradit bankovním převodem před turnajem nebo v hotovosti (EUR) při příjezdu. Platí se za pokoj, nikoli za osobu.',
    overFull: (hotel) => `${hotel} se právě vyprodal — vraťte se zpět a vyberte jiný hotel.`,
    overSome: (n, hotel, remove) => `V hotelu ${hotel} ${n === 1 ? 'zbývá už jen 1 pokoj' : `zbývají už jen ${n} pokoje`} — odeberte ${remove} ${remove === 1 ? 'pokoj' : remove < 5 ? 'pokoje' : 'pokojů'} nebo vyberte jiný hotel.`,
    btnContact: 'Kontaktní údaje',
    btnHotel: 'Vybrat hotel',
    btnRoom: 'Vybrat pokoj',
    btnGuests: 'Přidat hosty',
    btnReview: 'Shrnutí a odeslání',
    btnSubmit: 'Odeslat rezervaci',
    btnSubmitting: 'Odesílám…',
    btnBack: 'Zpět',
    btnClose: 'Zavřít',
    successTitle: 'Rezervace odeslána!',
    successText: 'Váš požadavek na ubytování byl přijat. Pořadatel jej potvrdí a zašle platební pokyny na váš e-mail.',
    confirmHotelChange: 'Změnou hotelu se odstraní vybrané pokoje. Pokračovat?',
    submitError: 'Omlouváme se, při odesílání rezervace došlo k chybě. Zkuste to prosím znovu.',
    roomTypes: {
      'Single room': 'Jednolůžkový pokoj',
      'Double room': 'Dvoulůžkový pokoj',
      'Triple room': 'Třílůžkový pokoj',
      '4-person room': 'Čtyřlůžkový pokoj',
      'Apartment (2-4 persons)': 'Apartmán (2–4 osoby)',
    },
  },

  reg: {
    notOpen: 'Registrace ještě není otevřena.',
    headerTitle: 'Registrace na turnaj',
    step1Title: 'Klub a kontakt',
    club: 'Název klubu',
    country: 'Země',
    managerTitle: 'Vedoucí družstva',
    singlesTitle: 'Přihlášky — dvouhry',
    doublesTitle: 'Přihlášky — čtyřhry',
    addSingles: 'Přidat hráče do dvouhry',
    addDoubles: 'Přidat pár do čtyřhry',
    noEntries: 'Zatím žádné přihlášky — tento krok můžete přeskočit.',
    player1: 'Hráč 1',
    player2opt: 'Hráč 2 (nepovinné)',
    partnerNote: 'Přihláška do čtyřhry je platná i s jedním hráčem — partnera lze doplnit později.',
    discipline: 'Disciplína',
    disciplines: {
      BS: 'Dvouhra — chlapci',
      GS: 'Dvouhra — dívky',
      BD: 'Čtyřhra — chlapci',
      GD: 'Čtyřhra — dívky',
      XD: 'Smíšená čtyřhra',
    },
    summaryTitle: 'Shrnutí registrace',
    clubLabel: 'Klub:',
    entriesLabel: 'Přihlášky:',
    entriesCount: (n) => `${n} ${n === 1 ? 'přihláška' : n < 5 ? 'přihlášky' : 'přihlášek'}`,
    needOneEntry: 'Před odesláním přidejte alespoň jednu přihlášku (dvouhra nebo čtyřhra).',
    btnSingles: 'Dvouhry',
    btnDoubles: 'Čtyřhry',
    btnSubmit: 'Odeslat registraci',
    successTitle: 'Registrace odeslána!',
    successText: 'Vaše přihlášky byly přijaty. Pořadatel potvrdí registraci e-mailem.',
  },
};

export default cz;
